import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateGcOUSettingForm } from '../../../../actions/organisation';
import { Checkbox } from 'semantic-ui-react';
import objectAssign from 'object-assign';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

const CenterPanelUpdate = ({ isAdmin, setSaveButtonDisableClass }) => {
  const dispatch = useDispatch();
  let htmlToReactParser = new HtmlToReact.Parser(React);
  const ouGcWaitingAreaSettings = useSelector((state) => state.organisationsReducer.ouGcSettings);
  const gcWaitngAreaOUSettingForm = useSelector((state) => state.organisationsReducer.gcWaitngAreaOUSettingForm);

  const gcOUFormSettingUpdated = (property, value) => {
    let updatedGcSettingForm = objectAssign({}, gcWaitngAreaOUSettingForm, { [property]: value });
    return updatedGcSettingForm;
  };

  const handleChatToggle = (event, data) => {
    if (ouGcWaitingAreaSettings.isChatEditable) {
      setSaveButtonDisableClass('');
      dispatch(
        updateGcOUSettingForm(gcOUFormSettingUpdated('isChatEnabled', !gcWaitngAreaOUSettingForm?.isChatEnabled))
      );
    }
  };
  const handleFullNameToggle = (event, data) => {
    if (ouGcWaitingAreaSettings.isCallerFullNameEditable) {
      setSaveButtonDisableClass('');
      dispatch(
        updateGcOUSettingForm(
          gcOUFormSettingUpdated('isCallerFullNameEnabled', !gcWaitngAreaOUSettingForm?.isCallerFullNameEnabled)
        )
      );
    }
  };

  return (
    <div className={isAdmin == true ? 'form minHeightLargerForm' : 'form'}>
      {ouGcWaitingAreaSettings?.isPortalChatEnabled && (
        <>
          <Checkbox
            tabIndex="1"
            className="mrbs"
            label={APP.LANGUAGE.GCSettings.ChatToggleTitle}
            checked={gcWaitngAreaOUSettingForm?.isChatEnabled}
            onClick={handleChatToggle}
            readOnly={ouGcWaitingAreaSettings.isChatEditable ? false : true}
          />
          <div className="checkbox-desc mrbs">{APP.LANGUAGE.GCSettings.ChatToggleDesc}</div>
        </>
      )}
      {ouGcWaitingAreaSettings?.isPortalCallerFullNameEnabled && (
        <>
          <Checkbox
            tabIndex="2"
            className="mrbs"
            label={APP.LANGUAGE.GCSettings.FullNameToggleTitle}
            onClick={handleFullNameToggle}
            checked={gcWaitngAreaOUSettingForm?.isCallerFullNameEnabled}
            readOnly={ouGcWaitingAreaSettings.isCallerFullNameEditable ? false : true}
          />
          <div className="checkbox-desc mrbs">{APP.LANGUAGE.GCSettings.FullNameToggleDesc}</div>
        </>
      )}
    </div>
  );
};

export default CenterPanelUpdate;
